var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPackageThird = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 56 39"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#package-third_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7F7F7",
  d: "M28 38.362c15.464 0 28-4.204 28-9.39 0-5.184-12.536-9.388-28-9.388S0 23.788 0 28.973s12.536 9.389 28 9.389"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#86735E",
  fillRule: "evenodd",
  d: "M44.573 26.374a.55.55 0 0 1-.343.344l-16.178 5.4a.5.5 0 0 1-.17.028h-.002a.5.5 0 0 1-.17-.028l-16.18-5.4a.58.58 0 0 1-.342-.344l16.692 2.903z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3BFAA",
  fillRule: "evenodd",
  d: "M11.534 6.04 27.713.6a.6.6 0 0 1 .164-.028h.015q.083.001.164.028l6.388 2.133c1.312.462 2.55.874 3.729 1.245l6.061 2.024c.221.074.37.281.37.514v19.688q0 .088-.027.17L27.884 31.96l-16.692-5.585a.5.5 0 0 1-.028-.17V6.517c0-.233.15-.404.37-.478",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B5A18A",
  fillRule: "evenodd",
  d: "M44.48 6.173a.54.54 0 0 1 .123.345v19.687q0 .089-.027.17L27.883 31.96V11.988a.36.36 0 0 1 .245-.344z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E2D5C8",
  fillRule: "evenodd",
  d: "M11.188 6.372a.46.46 0 0 1 .117-.194l16.668 5.575a.36.36 0 0 0-.085.209z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D7C5B3",
  fillRule: "evenodd",
  d: "M11.536 6.04 27.715.6a.6.6 0 0 1 .164-.028h.014q.084.001.165.028l6.388 2.133q1.82.641 3.729 1.245l6.122 2.049a.54.54 0 0 1 .186.145l-16.318 5.46a.44.44 0 0 0-.193.12l-.086-.027-16.581-5.549a.6.6 0 0 1 .231-.138",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B09B83",
  fillRule: "evenodd",
  d: "M11.461 6.698c-.04-.013-.11-.038-.11-.12 0-.088.09-.12.138-.104l16.155 5.407a.11.11 0 0 1 .081.12c-.002.064-.076.113-.137.097z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m34.446 2.734 3.729 1.245-16.508 5.524a.39.39 0 0 0-.279.374l.004 5.227a.312.312 0 0 1-.405.297l-3.116-1.043a.31.31 0 0 1-.207-.287V8.613c.01-.156.09-.275.253-.348z",
  clipRule: "evenodd",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#827D74",
  fillRule: "evenodd",
  d: "m31.333 26.895.789-.259a.15.15 0 0 0 .1-.134V24.1l.538-.177c.082-.027.13-.137.081-.187l-1.033-1.076c-.02-.02-.05-.024-.08-.015l-.003.001a.15.15 0 0 0-.08.068l-1.032 1.754c-.048.083 0 .161.082.134l.538-.177v2.403c0 .056.045.087.1.068m3.951-.014a.15.15 0 0 1-.1.133l-4.49 1.476c-.055.018-.1-.012-.1-.068v-.787c0-.056.045-.116.1-.134l4.49-1.475c.055-.019.1.012.1.067zm-.953-5.091-.184.06a.15.15 0 0 0-.08.067l-1.031 1.755c-.049.083-.001.16.081.133l.538-.176v2.402c0 .056.045.087.1.068l.79-.259a.15.15 0 0 0 .1-.134v-2.403l.538-.176c.082-.027.13-.137.081-.188l-1.033-1.075c-.02-.02.13-.084.1-.075",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E3DDD6",
  fillRule: "evenodd",
  d: "M19.771 9.247c0 .263-.538.168-.537-.18v-.118c0-.07.042-.132.121-.158L35.997 3.27l.537.179L19.77 9.011z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "package-third_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h56v38.362H0z"
})))));
export default SvgPackageThird;